export default [
  # Restricts on attributes
  {
    command: "restrict"
    type: 'Attribute restrictors'
    info: 'Restricts the resultset to a single or a set of ids'
    syntax: "restrict 'node'"
    usage: "restrict '9270c04a-25b6-4b99-b8f1-4bf66767e22x'"
  },
  {
    command: "contains"
    type: 'Attribute restrictors'
    info: 'Restrict the amount of results to the nodes where a specified attribute contains a specific text'
    syntax: "contains 'attribute' 'value'"
    usage: "contains 'name' 'weav'"
  },
  {
    command: "equalTo"
    type: 'Attribute restrictors'
    info: 'Restricts based on attributes.\nResults must match the passed key : value args'
    syntax: "equalTo 'key' 'value'"
    usage: "equalTo 'name' 'david'"
  },
  {
    command: "equalToIgnoreCase"
    type: 'Attribute restrictors'
    info: 'Restricts based on attributes.\nResults must match the passed key : value args, the attributes ignore case'
    syntax: "equalTo 'key' 'value'"
    usage: "equalTo 'name' 'daviD'"
  },
  {
    command: "notEqualTo"
    type: 'Attribute restrictors'
    info: 'Restricts based on attributes.\nResults must match the passed key : value args'
    syntax: "notEqualTo 'key' 'value'"
    usage: "notEqualTo 'name' 'david'"
  },
  {
    command: "startsWith"
    type: 'Attribute restrictors'
    info: 'Restrict resultset based on the beginning of an attribute'
    syntax: "startsWith 'key' 'value'"
    usage: "startsWith 'name' 'Ma'"
  },
  {
    command: "endsWith"
    type: 'Attribute restrictors'
    info: 'Restrict resultset based on the beginning of an attribute'
    syntax: "endsWith 'key' 'value'"
    usage: "endsWith 'companyname' 'er'"
  },
  {
    command: "exists"
    type: 'Attribute restrictors'
    info: 'Restricts resultset based on whether a given attribute exists'
    syntax: "exists 'key'"
    usage: "exists 'employeenumber'"
  },
  {
    command: "doesNotExist"
    type: 'Attribute restrictors'
    info: 'Restricts resultset based on whether a given attribute does not exist'
    syntax: "doesNotExist 'key'"
    usage: "doesNotExist 'phonenumber'"
  },
  {
    command: "lessThan"
    type: 'Attribute restrictors'
    info: 'Restrict based on attributes.\nThe attribute value must respect the mathematical rule described'
    syntax: "lessThan 'key' value"
    usage: "lessThan 'age' 23"
  },
  {
    command: "lessThanOrEqualTo"
    type: 'Attribute restrictors'
    info: 'Restrict based on attributes.\nThe attribute value must respect the mathematical rule described'
    syntax: "lessThanOrEqualTo 'key' value"
    usage: "lessThanOrEqualTo 'age' 28"
  },
  {
    command: "greaterThan"
    type: 'Attribute restrictors'
    info: 'Restrict based on attributes.\nThe attribute value must respect the mathematical rule described'
    syntax: "greaterThan 'key' value"
    usage: "greaterThan 'age' 38"
  },
  {
    command: "greaterThanOrEqualTo"
    type: 'Attribute restrictors'
    info: 'Restrict based on attributes.\nThe attribute value must respect the mathematical rule described'
    syntax: "greaterThanOrEqualTo 'key' value"
    usage: "greaterThanOrEqualTo 'age' 20"
  },

  # Restrict on relations
  {
    command: "hasRelationIn"
    type: 'Relation restrictors'
    info: "Restricts query based on incoming relations.\nThe 'key' argument is the relation key, and 'node' is the node of which the relation must originate from.\n'Node' is an optional argument here, if 'node' is not passed, then this criteria is considered passed as if ANY relation exists for the passed key."
    syntax: "hasRelationIn 'key' 'node'"
    usage: "hasRelationIn 'type' 'originatingNode'"
  },
  {
    command: "hasRelationOut"
    type: 'Relation restrictors'
    info: "Restricts query based on outgoing relations.\nThe 'key' argument is the relation key, and 'node' is the node of which the relation must originate from.\n'Node' is an optional argument here, if 'node' is not passed, then this criteria is considered passed as if ANY relation exists for the passed key."
    syntax: "hasRelationOut 'key' 'node'"
    usage: "hasRelationOut 'type' 'originatingNode'"
  },
  {
    command: "hasNoRelationIn"
    type: 'Relation restrictors'
    info: "Restricts query based on incoming relations.\nThe 'key' argument is the relation key, and node is the node which the relation must originate from.\nnode is an optional argument here, if node is not passed, then this criteria is considered passed if ANY relation exists for the passed key."
    syntax: "hasNoRelationIn 'key' 'node'"
    usage: "hasNoRelationIn 'type' 'originatingNode'"
  },
  {
    command: "hasNoRelationOut"
    type: 'Relation restrictors'
    info: "Restricts query based on outgoing relations.\nThe 'key' argument is the relation key, and node is the node which the relation must originate from.\nnode is an optional argument here, if node is not passed, then this criteria is considered passed if ANY relation exists for the passed key."
    syntax: "hasNoRelationOut 'key' 'node'"
    usage: "hasNoRelationIn 'type' 'originatingNode'"
  },
  {
    command: "hasRecursiveRelationIn"
    type: 'Relation restrictors'
    info: "Restricts query based on recursive incoming relations.\nThe 'key' argument is the relation key, and 'node' is the node of which the relation must originate from.\n'Node' is an optional argument here, if 'node' is not passed, then this criteria is considered passed as if ANY relation exists for the passed key."
    syntax: "hasNoRecursiveRelationOut 'key' 'node'"
    usage: "hasNoRecursiveRelationOut 'part-of' '9270c04a-25b6-4b99-b8f1-4bf66767e22x'"
  },
  {
    command: "hasRecursiveRelationOut"
    type: 'Relation restrictors'
    info: "Restricts query based on recursive outgoing relations.\nThe 'key' argument is the relation key, and 'node' is the node of which the relation must originate from.\n'Node' is an optional argument here, if 'node' is not passed, then this criteria is considered passed as if ANY relation exists for the passed key."
    syntax: "hasRecursiveRelationOut 'key' 'node'"
    usage: "hasRecursiveRelationOut 'part-of' '9270c04a-25b6-4b99-b8f1-4bf66767e22x'"
  },
  {
    command: "hasNoRecursiveRelationIn"
    type: 'Relation restrictors'
    info: "Restricts query based on recursive incoming relations.\nThe 'key' argument is the relation key, and node is the node which the relation must originate from.\nnode is an optional argument here, if node is not passed, then this criteria is considered passed if ANY relation exists for the passed key."
    syntax: "hasNoRecursiveRelationIn 'key' 'node'"
    usage: "hasNoRecursiveRelationIn 'part-of' '9270c04a-25b6-4b99-b8f1-4bf66767e22x'"
  },
  {
    command: "hasNoRecursiveRelationOut"
    type: 'Relation restrictors'
    info: "Restricts query based on recursive outgoing relations.\nThe 'key' argument is the relation key, and 'node' is the node of which the relation must originate from.\n'Node' is an optional argument here, if 'node' is not passed, then this criteria is considered passed as if ANY relation exists for the passed key."
    syntax: "hasNoRecursiveRelationOut 'key' 'node'"
    usage: "hasNoRecursiveRelationOut 'part-of' '9270c04a-25b6-4b99-b8f1-4bf66767e22x'"
  },


  # Add extra relations
  {
    command: "selectIn"
    type: 'Relation selectors'
    info: "Adds nodes to the resultset which have a relationOut containing (one of) the key(s) to one of the restricted nodes"
    syntax: "selectIn 'key'"
    usage: "selectIn 'employs'"
  },
  {
    command: "selectOut"
    type: 'Relation selectors'
    info: "Adds nodes to the resultset which have a relationIn containing (one of) the key(s) from one of the restricted nodes"
    syntax: "selectOut 'key'"
    usage: "selectOut 'worksAt'"
  },
  {
    command: "selectRecursiveIn"
    type: 'Relation selectors'
    info: "Adds nodes recursively to the resultset which have a relationOut containing (one of) the key(s) to one of the restricted nodes"
    syntax: "selectRecursiveIn 'key'"
    usage: "selectRecursiveIn 'consistsOf'"
  },
  {
    command: "selectRecursiveOut"
    type: 'Relation selectors'
    info: "Adds nodes recursively to the resultset which have a relationIn containing (one of) the key(s) from one of the restricted nodes"
    syntax: "selectRecursiveOut 'key'"
    usage: "selectRecursiveOut 'consistsOf'"
  },


  # Meta restrictors
  {
    command: "inGraph"
    type: 'Meta restrictors'
    info: 'Restricts based on a specified graph'
    syntax: "inGraph 'graph'"
    usage: "inGraph 'myGraph'"
  },
  {
    command: "limit"
    type: 'Meta restrictors'
    info: 'Limits the amount of results (default/maximum permitted is 1,000).\nLimit command must be placed on a new line'
    syntax: "limit value"
    usage: "hasRelationIn '*'\nlimit 1"
  },

  # Time restrictors on attributes
  {
    command: "greaterThan"
    type: 'Time restrictors'
    info: "Restrict based on attribute with datetime value.\n The 'value' argument can be day(s), week(s), month(s) and year(s)."
    syntax: "greaterThan 'key' now 'value'"
    usage: "greaterThan 'date' now '- 1 day' \ngreaterThan 'time' now '+ 3 weeks'"
  },
  {
    command: "lessThan"
    type: 'Time restrictors'
    info: "Restrict based on attribute with datetime value. \n The 'value' argument can be day(s), week(s), month(s) and year(s)."
    syntax: "lessThan 'key' now 'value'"
    usage: "lessThan 'dateAttr' now '- 8 months' \nlessThan 'date' now '+ 1 year'"
  }
]
